import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useRestaurant } from '../../providers/RestaurantContext';
import { signOut as firebaseSignOut } from 'firebase/auth';
import { auth } from '../../config/firebase/auth';
import { Building2, Users, Database, Settings, LogOut } from 'lucide-react';

// CHANGE THIS TO YOUR EMAIL
const SUPER_ADMIN_EMAILS = ['yappppp.adm@gmail.com'];  // 👈 Your email from screenshot

export default function SuperAdminLayout() {
  const { user } = useRestaurant();
  const location = useLocation();

  // Check if user is logged in
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if user is super admin
  if (!SUPER_ADMIN_EMAILS.includes(user.email || '')) {
    return <Navigate to="/admin" />;
  }

  const navigation = [
    { name: 'Panel de Control', href: '/super-admin', icon: Building2 },
    { name: 'Restaurantes', href: '/super-admin/restaurants', icon: Users },
    { name: 'Crear Restaurante', href: '/super-admin/create', icon: Settings },
    { name: 'Herramienta de Migración', href: '/super-admin/migration', icon: Database },
  ];

  const isActive = (path: string) => {
    if (path === '/super-admin') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const handleSignOut = async () => {
    try {
      await firebaseSignOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div className="w-64 bg-gray-900 text-white flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-800">
          <h1 className="text-2xl font-bold">YAP</h1>
          <p className="text-sm text-gray-400 mt-1">Super Administrador</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {navigation.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.href);
            
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${
                  active
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`}
              >
                <Icon size={20} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* User Info & Logout */}
        <div className="p-4 border-t border-gray-800">
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm">
              <p className="font-medium truncate">{user.email}</p>
              <p className="text-gray-400 text-xs">Super Administrador</p>
            </div>
          </div>
            <button
              onClick={handleSignOut}
              className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition text-sm"
            >
            <LogOut size={16} />
            Cerrar Sesión
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}